module.exports = __webpack_public_path__ + "prod/1.42.2/img/solutionCgcj.a5360eb4.png";